import { $, _, Backbone, Radio, moment, Foundation, Datepicker } from "../../../vendor";
import { Biscuit } from "../../utils";
import Inboomai18n from "../../utils/Inboomai18n";
import { parseUrlIntoObject, getEnvPrefix } from "../../utils/Uri";
import InboomaBaseView from "../InboomaBaseView";

import SidebarFilterBehavior from "../../behaviors/Behavior.SidebarFilter";

import ReservationsSidebarTpl from "../../templates/reservationsList/ReservationsSidebarTpl.html";
import Contingents from "../../collections/Contingents";
import { getApiHost } from "../../Sync";
import * as FileSaver from "../../../vendor/FileSaver";
import { select2 } from "../../../vendor";
import { getContentModifications } from "../../App";

export default InboomaBaseView.extend({
  template: ReservationsSidebarTpl,
  el: "#inb-c-sidebar",
  _filterSettings: [],
  _controllerHistory: {
    currentController: {}, // currently called controller
    previousController: {}, // previously called controller
    beforePrevCtrl: {}, // controller called before previous controller
  },

  templateContext() {
    // Shall we reduce location items for this user?
    let managerHasLocations = Biscuit.get("user.user_locations");

    if (managerHasLocations !== "") {
      managerHasLocations = managerHasLocations.split(",");
    }

    let locations = Radio.channel("locationsWithTrashed").request("get:data").getAllLocations();

    locations = _.sortBy(locations, (location) => location.get("name"));

    let networks = Radio.channel("networks").request("get:data");

    // networks =  _.sortBy(networks, network => network.get('name'));
    const host = getEnvPrefix();

    this._getContingentList();
    this._getNetworkList();

    const isHiddenElement = (id) => {
      let cm = getContentModifications();
      if (cm.hidden_elements != null && cm.hidden_elements.length > 0) {
        for (var i = 0; i < cm.hidden_elements.length; i++) {
          if (cm.hidden_elements[i] == id) return true;
        }
      }
      return false;
    };

    const _exchangeLabel = (value) => {
      let cm = getContentModifications();
      if (cm.labels != null) {
        if (cm.labels[value] !== undefined) {
          return cm.labels[value];
        }
      }
      return value;
    };

    return {
      _,
      moment,
      Biscuit,
      managerHasLocations,
      // Duplicate with OrdersSidebarView.js
      schedule: `https://${host}cal.inbooma.net?hash=${Biscuit.get("client.hash")}`,
      heart_schedule: `https://${host}cal.inbooma.net?hash=${Biscuit.get(
        "client.hash"
      )}&network=herzroute`,
      // /Duplicate
      params: parseUrlIntoObject(),
      locations,
      networks,
      _exchangeLabel,
      isHiddenElement,
    };
  },

  ui: {
    dropdown: ".inb-dropdown",
    dateStartField: "#inb-c-left-bar-flist--dates-start",
    dateEndField: "#inb-c-left-bar-flist--dates-end",
    flistDateCondition: "#inb-c-left-bar-flist--date-condition",
    flistDates: "#inb-c-left-bar-flist--dates",
    flistStatusCondition: "#inb-c-left-bar-flist--reservation-status",
    selectCheckinLocation: "#inb-c-left-bar-flist--begin-location-select",
    selectCheckoutLocation: "#inb-c-left-bar-flist--end-location-select",
    selectContingent: "#inb-c-left-bar-flist--contingent-select",
    selectNetwork: "#inb-c-left-bar-flist--network-select",
    dropdown: "#choose-new-order",
    addOrderNewCustomer: "#add-order-new-customer",
    backButton: "#back-button-container",
  },

  events: {
    "click .inb-toggle-sidebar-dd": "_initDropdown",
    "click @ui.flistDates .unset-filter": "_unsetStartEndFilter",
    "click #order-sidebar-tags-update-btn": "_updateTagList",
    "click .inb-fake-tag": "_triggerTag",
    "click #export-xls": "_export",
  },

  behaviors: [
    {
      // Note: "Unset all filters once"-feature has been
      // disabled on this view
      behaviorClass: SidebarFilterBehavior,
      onEmptyFilter: (view) => view.resetSidebarFilter,
      filterMap: {
        "date-condition": (view, filterVal) => {
          let sortDir, sortVal;

          view.collection
            .removeFilter("date-end", false)
            .removeFilter("date-begin", false)
            .removeFilter("upcoming", false)
            .removeFilter("past", false)
            .removeFilter("starts_today", false)
            .removeFilter("ends_today", false)
            .removeFilter("ends_upcoming", false)
            .removeFilter("begin_gte", false)
            .removeFilter("end_lt", false);

          if (typeof view.collection._filterParams !== "undefined") {
            view._CleanupDateTimeFilters(view);
          }

          // Reset datepickers
          view.getUI("dateStartField").removeClass("active").find("span").html("");

          view.getUI("dateEndField").removeClass("active").find("span").html("");

          view.datepickerStart.gotoToday();
          view.datepickerEnd.gotoToday();

          switch (filterVal) {
            case "date-all":
              sortDir = "desc";
              sortVal = "id";
              view.collection._sorted._direction = sortDir;
              view.collection._sorted._comparator = sortVal;
              //view.collection.setFilterAndSort('all', '', sortVal, sortDir, 'date-all');
              view.collection.setSort(sortVal, sortDir, true);
              // don't set any filter to get all reservations
              view._updateFilterSettings({
                filter: "date-all",
                type: "date-condition",
                value: "",
              });
              break;

            case "upcoming":
              console.log("upcoming");
              sortDir = "asc";
              sortVal = "begin";
              view.collection._sorted._direction = sortDir;
              view.collection._sorted._comparator = sortVal;
              //view.collection.setFilterAndSort('begin_gte', moment().format('YYYY-MM-DD H:mm:ss'), sortVal, sortDir, 'upcoming');
              view.collection.setSort(sortVal, sortDir, false);
              view.collection.addFilter("begin_gte", moment().format("YYYY-MM-DD"), true);
              view._updateFilterSettings({
                filter: "upcoming",
                type: "date-condition",
                value: moment().format("YYYY-MM-DD"),
              });
              break;

            case "past":
              sortDir = "desc";
              sortVal = "end";
              view.collection._sorted._direction = sortDir;
              view.collection._sorted._comparator = sortVal;
              //view.collection.setFilterAndSort('end_lt', moment().format('YYYY-MM-DD H:mm:ss'), sortVal, sortDir, 'past');
              view.collection.setSort(sortVal, sortDir, false);
              view.collection.addFilter("end_lt", moment().format("YYYY-MM-DD H:mm:ss"), true);
              //this.collection.addFilter('begin_gte', moment(date).format('YYYY-MM-DD 00:00:00'));

              view._updateFilterSettings({
                filter: "past",
                type: "date-condition",
                value: moment().format("YYYY-MM-DD H:mm:ss"),
              });
              break;

            case "starts_today":
              sortDir = "asc";
              sortVal = "begin";
              view.collection._sorted._direction = sortDir;
              view.collection._sorted._comparator = sortVal;
              //view.collection.setFilterAndSort('begin_day', moment().format('YYYY-MM-DD'), sortVal, sortDir, 'starts_today');
              view.collection.setSort(sortVal, sortDir, false);
              view.collection.addFilter("begin_day", moment().format("YYYY-MM-DD"), true);
              view._updateFilterSettings({
                filter: "starts_today",
                type: "date-condition",
                value: moment().format("YYYY-MM-DD"),
              });
              break;

            case "ends_today":
              sortDir = "asc";
              sortVal = "end";
              view.collection._sorted._direction = sortDir;
              view.collection._sorted._comparator = sortVal;
              //view.collection.setFilterAndSort('end_day', moment().format('YYYY-MM-DD'), sortVal, sortDir, 'ends_today');
              view.collection.setSort(sortVal, sortDir, false);
              view.collection.addFilter("end_day", moment().format("YYYY-MM-DD"), true);
              view._updateFilterSettings({
                filter: "ends_today",
                type: "date-condition",
                value: moment().format("YYYY-MM-DD"),
              });
              break;
            case "ends_upcoming":
              sortDir = "asc";
              sortVal = "end";
              view.collection._sorted._direction = sortDir;
              view.collection._sorted._comparator = sortVal;
              view.collection.setSort(sortVal, sortDir, false);
              view.collection.addFilter("end_gte", moment().format("YYYY-MM-DD"), false);
              view._updateFilterSettings({
                filter: "ends_upcoming",
                type: "date-condition",
                value: moment().format("YYYY-MM-DD"),
              });
              view
                .getUI("flistStatusCondition")
                .find('li[data-inb-val="inprogress"]')
                .trigger("click");
          }
        },
        "reservation-status": (view, filterVal) => {
          //view.collection.setFilterAndSort('status', filterVal, null, null, 'reservation-status');
          if (filterVal == "cancelled") {
            console.log("cancelled");
            view.collection.removeFilter("finder", false);
          } else {
            var hasFinder = false,
              filter = view.collection.getFilters();

            for (var i = 0; i < filter.length; i++) {
              if (filter[i] == "finder") {
                hasFinder = true;
              }
            }
            if (!hasFinder) {
              view.collection.addFilter("finder", "NotCancelled", false);
            }
          }
          if (filterVal == "reset") {
            console.log("reset");
            view.collection.removeFilter("status", true);
          } else {
            view.collection.addFilter("status", filterVal, true);
          }
          //view._updateFilterSettings({'filter' : 'reservation-status', 'type' : 'reservation-status', 'value' : filterVal});
        },
        tag: (view, filterVal) => {
          //view.collection.filterByTag(filterVal);
          view.collection.addFilter("order_tags", filterVal, true);
        },
      },
    },
  ],

  resetSidebarFilter(view) {
    this.getUI("flistDates").find("li").removeClass("active").find("span").html("");

    if (typeof view.collection._filterParams !== "undefined") {
      view._CleanupDateTimeFilters(view);

      delete view.collection._filterParams.status;
      delete view.collection._filterParams.begin_location;
      delete view.collection._filterParams.end_location;
    }

    let sortDir = "asc",
      sortVal = "begin";

    view.collection._sorted._direction = sortDir;
    view.collection._sorted._comparator = sortVal;

    view.collection.removeAllFilter();

    view._updateFilterSettings({
      filter: "date-all",
      type: "date-condition",
      value: moment().format("YYYY-MM-DD H:mm:ss"),
    });
    this.render();
  },

  _getContingentList() {
    // fetch contingent select: 'api/contingents?findForSelect=true'
    const RequestHelper = Backbone.Model.extend({
      urlRoot: "/contingents?findForSelect=true",
    });

    new RequestHelper(null).fetch({
      success(model, response) {
        if (response.success && response.data.length > 0) {
          // put tags into list of available tags
          var sel = document.getElementById("inb-c-left-bar-flist--contingent-select");
          if (sel !== undefined && sel != null) {
            for (var i = 0; i < response.data.length; i++) {
              var opt = document.createElement("option");
              opt.text = response.data[i].name;
              opt.value = response.data[i].id;
              sel.appendChild(opt);
            }
          }
        } else {
          console.log("ERROR: failed to get contingent list");
        }
      },
      error(model, response) {
        console.log("Error, could not request contingents list.");
      },
    });
  },

  _getNetworkList() {
    const RequestHelper = Backbone.Model.extend({ urlRoot: "/networks" });
    new RequestHelper(null).fetch({
      success(model, response) {
        if (response.success && response.data.length > 0) {
          // put tags into list of available tags
          var sel = document.getElementById("inb-c-left-bar-flist--network-select");
          if (sel !== undefined && sel != null) {
            for (var i = 0; i < response.data.length; i++) {
              var opt = document.createElement("option");
              opt.text = response.data[i].name;
              opt.value = response.data[i].id;
              sel.appendChild(opt);
            }
          }
        } else {
          console.log("ERROR: failed to get network list");
        }
      },
      error(model, response) {
        console.log("Error, could not request networks list.");
      },
    });
  },

  _datePickerStartOnSelect(date, triggerFetch = true) {
    this.datepickerEnd.gotoDate(moment(date).toDate());

    this.getUI("flistDateCondition").find(".active").removeClass("active");

    this.getUI("flistDateCondition").find('li[data-inb-val="date-all"]').addClass("active");

    this.getUI("dateStartField")
      .addClass("active")
      .find("span")
      .html(" - " + moment(date).format("D. MMMM YYYY"));

    if (triggerFetch) {
      // Use native InboomaFilterableCollection sort & filter API
      this.collection.setSort("begin", "asc", false);

      if (!this.getUI("dateEndField").hasClass("active")) {
        this.collection
          .removeFilter("end_lt", false)
          .removeFilter("end_gte", false)
          .removeFilter("end_day", false);
      }

      this.collection.addFilter("begin_gte", moment(date).format("YYYY-MM-DD 00:00:00"));
    }

    //this._updateFilterSettings({'filter' : 'begin_gte', 'type' : 'dates', 'value' : date});

    this.collection.trigger("select:filter");
  },

  _datePickerEndOnSelect(date, triggerFetch = true) {
    this.getUI("flistDateCondition").find(".active").removeClass("active");

    this.getUI("flistDateCondition").find('li[data-inb-val="date-all"]').addClass("active");

    this.getUI("dateEndField")
      .addClass("active")
      .find("span")
      .html(" - " + moment(date).format("D. MMMM YYYY"));

    if (triggerFetch) {
      // Use native InboomaFilterableCollection sort & filter API
      // set sort only if date picker start not set
      if (!this.getUI("dateStartField").hasClass("active")) {
        this.collection.removeFilter("begin_gte", false).removeFilter("begin_day", false);
        this.collection.setSort("begin", "desc", false);
      }

      this.collection.addFilter("begin_lt", moment(date).format("YYYY-MM-DD") + " 23:59:59");
    }

    this._updateFilterSettings({
      filter: "begin_lt",
      type: "dates",
      value: date,
    });

    this.collection.trigger("select:filter");
  },

  _CleanupDateTimeFilters(view) {
    delete view.collection._filterParams.begin_gte;
    delete view.collection._filterParams.begin_lt;
    delete view.collection._filterParams.end_lt;
    delete view.collection._filterParams.end_gte;
    delete view.collection._filterParams.begin_day;
    delete view.collection._filterParams.end_day;
  },

  _initDropdown(ev) {
    ev.preventDefault();

    if (typeof this._dropdown === "undefined") {
      this._dropdown = new Foundation.Dropdown($("#inb-c-sidebar .inb-dropdown"));
    }

    this._dropdown.open();

    return false;
  },

  _destroyDatepickers() {
    if (typeof this.datepickerStart !== "undefined") {
      this.datepickerStart.destroy();
    }

    if (typeof this.datepickerEnd !== "undefined") {
      this.datepickerEnd.destroy();
    }
  },

  // Called by each filter function
  _updateFilterSettings(newFilter) {
    // remove all filter and exit
    if (typeof newFilter.filter == "undefined") {
      this._filterSettings.filter = "upcoming";
      this._filterSettings.type = "date-condition";
      this._filterSettings.value = moment().format("YYYY-MM-DD H:mm:ss");

      this.options.controller.storeFilterSettingsOfCollection(this, this._filterSettings);
      //        return;
    }

    // unselect multiple selection
    if (
      newFilter.filter == "checkinLocationRemove" ||
      newFilter.filter == "checkoutLocationRemove" ||
      newFilter.filter == "contingentRemove"
    ) {
      for (let i = 0; i < this._filterSettings.length; i++) {
        if (
          this._filterSettings[i].type == newFilter.type &&
          this._filterSettings[i].value == newFilter.value
        ) {
          this._filterSettings.splice(i, 1);
          i--;
        }
      }
    }

    // check if other filter have to be removed - remove all filter from settings with same type
    if (
      newFilter.type == "date-condition" ||
      newFilter.type == "reservation-status" ||
      newFilter.type == "paystate" ||
      newFilter.type == "checkin" ||
      newFilter.type == "checkin-location" ||
      newFilter.type == "checkout-location" ||
      newFilter.type == "contingent"
    ) {
      for (let i = 0; i < this._filterSettings.length; i++) {
        if (this._filterSettings[i].type == newFilter.type) {
          this._filterSettings.splice(i, 1);
          i--;
        }
      }
    }

    this._filterSettings.push(newFilter);
    this.options.controller.storeFilterSettingsOfCollection(this, this._filterSettings);
  },

  // restore all given filter settings in view and collection
  // @todo We should brainstorm about another solution to implement this behavior.
  // Reason: When being called with non-empty filterSettings, the triggered $(...).click()
  // will make multiple - unneccessary - calls to the reservations-endpoint.
  _restoreFilterSettings(filterSettings) {
    const that = this;

    if (document.location.href.indexOf("contingent_id=") > 0) {
      // set filter to all by default if contingent-id is requested
      let cont_id = document.location.href.slice(
        document.location.href.indexOf("contingent_id=") + 14
      );
      that.collection.setFilterAndSort("contingent_id", cont_id, "begin", "desc", "contingent");

      let sel = "li[data-inb-val=date-all]";
      that.$el.find("#inb-c-left-bar-flist--date-condition").find(sel).trigger("click");
      return;
    }

    if (filterSettings.length == 0) {
      // set default filter if empty and no contingent-id is requested
      filterSettings = [
        {
          filter: "upcoming",
          type: "date-condition",
          value: moment().format("YYYY-MM-DD HH:mm:ss"),
        },
        {
          filter: "reservation-status",
          type: "reservation-status",
          value: "reset",
        },
      ];

      return;
    }

    let _filterSettings = {};

    _.extend(_filterSettings, filterSettings); // cloning is necessary cause we sometimes delete items inside the original settings array

    let begin_gte = false,
      end_lt = false;

    _.each(_filterSettings, (filter) => {
      switch (filter.type) {
        case "date-condition":
          let defaultValue = that.$el
            .find("ul.inb-vert-list")
            .find("li.is-default")
            .attr("data-inb-val");

          that.$el
            .find("#inb-c-left-bar-flist--date-condition")
            .find('li[data-inb-val="' + filter.filter + '"]')
            .trigger("click");
          break;

        case "dates":
          if (filter.filter == "begin_gte") {
            begin_gte = filter.value;
          } else if (filter.filter == "end_lt") {
            end_lt = filter.value;
          }
          break;

        case "reservation-status":
          that.$el
            .find("#inb-c-left-bar-flist--reservation-status")
            .find('li[data-inb-val="' + filter.value + '"]')
            .trigger("click");
          break;

        case "checkin":
          that.$el
            .find("#inb-c-left-bar-flist--begin")
            .find('li[data-inb-val="' + filter.filter + '"]')
            .trigger("click");
          break;

        case "checkin-location":
          let event = $.Event("select2:select");
          event.params = {};
          event.params.data = {};
          event.params.data.id = filter.value;
          that.getUI("selectCheckinLocation").trigger(event); // sets filter but does not set selected option in select2
          break;

        case "checkout-location":
          // set location filter
          let _event = $.Event("select2:select");
          _event.params = {};
          _event.params.data = {};
          _event.params.data.id = filter.value;
          that.getUI("selectCheckoutLocation").trigger(_event); // sets filter but does not set selected option in select2
          break;

        case "contingent_id":
          // set contingent filter
          let __event = $.Event("select2:select");
          __event.params = {};
          __event.params.data = {};
          __event.params.data.id = filter.value;
          that.getUI("selectContingent").trigger(__event); // sets filter but does not set selected option in select2
          break;

        case "network_id":
          // set contingent filter
          let ___event = $.Event("select2:select");
          ___event.params = {};
          ___event.params.data = {};
          ___event.params.data.id = filter.value;
          that.getUI("selectNetwork").trigger(___event); // sets filter but does not set selected option in select2
      }
    });

    // As the methods below work a bit differently, we execute them
    // at the end of this procedure.
    if (begin_gte) {
      that._datePickerStartOnSelect(begin_gte, !end_lt);
    }

    if (end_lt) {
      that._datePickerEndOnSelect(end_lt, true);
    }
  },

  _export() {
    const that = this;
    let params = "",
      count = 0,
      begin = null,
      end = null;
    _.each(this.collection.getFiltersWithValue(), (val, type) => {
      if (count > 0) {
        params += "&" + type + "=" + val;
      } else {
        params += "?" + type + "=" + val;
      }
      count++;
      if (type == "begin_gte" || type == "begin_gt") {
        begin = val;
      }
      if (type == "begin_lte" || type == "begin_lt") {
        end = val;
      }
    });
    let timestring = "";
    if (begin !== null) {
      timestring = that.t("von") + " " + that.get_date(begin) + " ";
    }
    if (end !== null) {
      timestring += that.t("bis") + " " + that.get_date(end) + " ";
    }
    const xmlHttp = new XMLHttpRequest();

    xmlHttp.open("GET", getApiHost() + "/reservations/export" + params, true);

    //  xmlHttp.setRequestHeader('Accept', 'application/json')
    xmlHttp.setRequestHeader("Authorization", "Bearer " + Biscuit.get("token"));
    xmlHttp.responseType = "blob";

    xmlHttp.onload = function () {
      const blob = new Blob([xmlHttp.response], { type: "application/xls" });
      FileSaver.saveAs(blob, that.t("reservations") + " " + that.get_date() + ".xlsx");
    };

    xmlHttp.send(null);
  },
  get_date(date = null) {
    let today = new Date();
    if (date !== null) {
      today = new Date(date);
    }
    let day = today.getDate(); // Tag

    // Monatsangabe startet bei 0!
    let month = today.getMonth() + 1; // Monat

    let year = today.getFullYear(); // Jahr
    if (day < 10) {
      day = "0" + day;
    }
    if (month < 10) {
      month = "0" + month;
    }
    today = day + "." + month + "." + year;

    return today;
  },

  initialize() {
    const appChannel = Radio.channel("app"),
      that = this,
      onRouterExecute = function (from, to) {
        if (to.controllerName !== "reservationsList") {
          that._destroyDatepickers();
        }

        appChannel.off("router:execute", onRouterExecute);
      };

    // listen to router channel to update controller history
    appChannel.on("router:history", (history) => {
      that._controllerHistory.currentController = history.currentController;
      that._controllerHistory.previousController = history.previousController;
      that._controllerHistory.beforePrevCtrl = history.beforePrevCtrl;
      console.log("history: ", that._controllerHistory);
    });

    appChannel.on("router:execute", onRouterExecute);

    this.render();

    if (
      (this._controllerHistory.previousController !== undefined &&
        (this._controllerHistory.previousController == "reservationsList" ||
          this._controllerHistory.previousController == "orders")) ||
      document.location.href.indexOf("contingent_id") > 0
    ) {
      this._restoreFilterSettings(this.options.controller.getStoredFilterSettingsOfCollection());
    }
    // initially show unset button for default filter
    this.getUI("flistDateCondition")
      .find("li.is-default.active")
      .find("a.unset-filter")[0].style.display = "block";
  },

  _updateTagList() {
    const that = this;

    // fetch order tags
    const RequestHelper = Backbone.Model.extend({
      urlRoot: "/tags?namespace=Orders",
    });

    new RequestHelper(null).fetch({
      success(model, response) {
        console.log("response: ", response);

        if (response.success) {
          // put tags into list of available tags, clear tags
          console.log("update tags");
          var fakeTagBox,
            tagBox = document.getElementById("inb-c-left-bar-flist--tag");
          for (var i = 0; i < tagBox.childNodes.length; i++) {
            if (tagBox.childNodes[i].tagName == "LI") {
              tagBox.removeChild(tagBox.childNodes[i]);
              i--;
            } else if (tagBox.childNodes[i].tagName == "UL") {
              fakeTagBox = tagBox.childNodes[i];
              fakeTagBox.innerHTML = "";
            }
          }
          // set hidden tags and fake tags
          for (var i = 0; i < response.data.length; i++) {
            // hidden tags
            var tag = document.createElement("li");
            var content = document.createElement("a");
            content.innerHTML = response.data[i].label;
            content.setAttribute("href", "#");
            content.setAttribute("class", "order-sidebar-tag-link");
            tag.setAttribute("class", "hide");
            tag.setAttribute("data-counter", response.data[i].counter);
            tag.setAttribute("data-inb-val", response.data[i].label);
            tag.setAttribute("title", that.t("filter_tag_${a}", { a: response.data[i].label }));
            tag.appendChild(content);
            tagBox.appendChild(tag);

            // fake tags
            if (fakeTagBox === undefined) continue;
            var fakeTag = document.createElement("li");
            var fakeContent = document.createElement("a");
            fakeContent.innerHTML = response.data[i].label;
            fakeContent.setAttribute("href", "#");
            fakeTag.setAttribute("class", "inb-fake-tag");
            fakeTag.setAttribute("data-counter", response.data[i].counter);
            fakeTag.setAttribute("data-inb-val", response.data[i].label);
            fakeTag.setAttribute("title", that.t("filter_tag_${a}", { a: response.data[i].label }));
            fakeTag.appendChild(fakeContent);
            fakeTagBox.appendChild(fakeTag);
          }
        } else {
          console.log("ERROR: failed to get tags response");
        }
      },
      error(model, response) {
        console.log("Error, could not request tags.");
      },
    });
  },

  _triggerTag(ev) {
    // get corresponding tag and trigger it
    var fakeTagBox = ev.target.parentNode.parentNode;
    var tagIndex,
      tagBox = fakeTagBox.parentNode;
    for (var i = 0; i < fakeTagBox.childNodes.length; i++) {
      if (fakeTagBox.childNodes[i].childNodes[0] == ev.target) {
        tagIndex = i;
        break;
      }
    }
    if (tagIndex === undefined) return;

    for (var j = -1, i = 0; i < tagBox.childNodes.length; i++) {
      if (tagBox.childNodes[i].tagName == "LI") {
        j++;
      }
      if (j == tagIndex) {
        $(tagBox.childNodes[i]).trigger("click");
        return;
      }
    }
  },

  onRender() {
    const that = this;

    this._destroyDatepickers();

    this.datepickerStart = new Datepicker({
      i18n: Inboomai18n.getPikadayI18n(),
      firstDay: 1, // monday
      field: this.getUI("dateStartField")[0],
      trigger: this.getUI("dateStartField")[0],
      defaultDate: new Date(),
      onSelect: (date) => {
        that._datePickerStartOnSelect(date);
      },
      onClose: () => {
        if (that.getUI("dateStartField").find("span").html() === "") {
          that.getUI("dateStartField").removeClass("active");
          // proof if other datepicker is active -> if not set default date-filter
          if (that.getUI("dateEndField").hasClass("active")) {
            that.collection.setSort("begin", "desc", false);
            that.collection.removeFilter("begin_gte").trigger("unselect:filter");
          } else {
            that.collection.removeFilter("begin_gte", false);
            // trigger default date filter
            // to-do: find a better solution than a time out (direct execution does not work - find a callback)
            window.setTimeout(function () {
              that.$(that.getUI("flistDateCondition").find(".is-default")[0]).trigger("click");
            }, 500);
          }
          //that._updateFilterSettings({});
          //that.collection.removeFilter('begin_gte')
          //             .trigger('unselect:filter');
        }
      },
    });

    this.datepickerEnd = new Datepicker({
      i18n: Inboomai18n.getPikadayI18n(),
      field: this.getUI("dateEndField")[0],
      firstDay: 1, // monday
      defaultDate: new Date(),
      onSelect: (date) => {
        that._datePickerEndOnSelect(date);
      },
      onClose: () => {
        return;
        if (that.getUI("dateEndField").find("span").html() === "") {
          that.getUI("dateEndField").removeClass("active");
          // proof if other datepicker is active -> if not set default date-filter
          if (that.getUI("dateStartField").hasClass("active")) {
            that.collection.removeFilter("begin_lt").trigger("unselect:filter");
          } else {
            that.collection.removeFilter("begin_lt", false);
            // trigger default date filter
            // to-do: find a better solution than a time out (direct execution does not work - find a callback)
            window.setTimeout(function () {
              that.$(that.getUI("flistDateCondition").find(".is-default")[0]).trigger("click");
            }, 500);
          }
          //                    that._updateFilterSettings({});
          //that.collection.removeFilter('begin_lt')
          //             .trigger('unselect:filter');
        }
      },
    });

    // Initialize select2
    // Note that we need the matcher method due to an unknown bug
    // which prevents select2 from filtering (value of null was passed to matcher)

    // CHECKIN LOCATION FILTER
    this.getUI("selectCheckinLocation")
      .select2({
        placeholder: this.t(
          "select_${a}",
          {
            a: this.t(this.templateContext()._exchangeLabel("location_of_checkin")),
          },
          "capital"
        ),
        maximumSelectionLength: 1,
        allowClear: true,
        matcher: (__, location) => {
          const val = that.$el
            .find("#inb-c-left-bar-flist--begin-location .select2-search__field")
            .val()
            .toLowerCase();

          if (val == null || val == "") return location;

          if (location.text.toLowerCase().indexOf(val) > -1) return location;

          return null; // no result
        },
      })
      .on("select2:select", function (e) {
        const data = e.params.data,
          filterVal = data.id;

        that.$el.find("#hidden-checkin-location-filter").trigger("click");

        that.collection.addFilter("begin_location", filterVal, true);

        that._updateFilterSettings({
          filter: "checkinLocation",
          type: "checkin-location",
          value: filterVal,
        });
        // hide input field
        that.$el
          .find("#inb-c-left-bar-flist--begin-location .select2-search__field")
          .addClass("hide");
      })
      .on("select2:unselect", function (e) {
        const data = e.params.data,
          filterVal = data.id;

        that._updateFilterSettings({
          filter: "checkinLocationRemove",
          type: "checkin-location",
          value: filterVal,
        });

        that.$el.find("#hidden-checkin-location-filter .unset-filter").trigger("click");
        that.$el
          .find("#inb-c-left-bar-flist--begin-location .select2-search__field")
          .val(null)
          .trigger("change");

        // Burnout solution in 3...2...1:
        $(that).data("state", "unselected");
        that.$el.data("state", "unselected");
        $(this).data("state", "unselected");

        const self = $(this);

        setTimeout(function () {
          self.select2("close");
          // show input field
          that.$el
            .find("#inb-c-left-bar-flist--begin-location .select2-search__field")
            .removeClass("hide");
        }, 1);
      });

    // CHECKOUT LOCATION FILTER
    this.getUI("selectCheckoutLocation")
      .select2({
        placeholder: this.t("select_${a}", { a: this.t("location_of_checkout") }, "capital"),
        maximumSelectionLength: 1,
        allowClear: true,
        matcher: (__, location) => {
          const val = that.$el
            .find("#inb-c-left-bar-flist--end-location .select2-search__field")
            .val()
            .toLowerCase();

          if (val == null || val == "") return location;

          if (location.text.toLowerCase().indexOf(val) > -1) return location;

          return null; // no result
        },
      })
      .on("select2:select", function (e) {
        const data = e.params.data,
          filterVal = data.id;

        that.$el.find("#hidden-checkout-location-filter").trigger("click");

        that.collection.addFilter("end_location", filterVal, true);
        that._updateFilterSettings({
          filter: "checkoutLocation",
          type: "checkout-location",
          value: filterVal,
        });
        // hide input field
        that.$el
          .find("#inb-c-left-bar-flist--end-location .select2-search__field")
          .addClass("hide");
      })
      .on("select2:unselect", function (e) {
        const data = e.params.data,
          filterVal = data.id;

        that.$el.find("#hidden-checkout-location-filter .unset-filter").trigger("click");
        that.$el.find("#inb-c-left-bar-flist--end-location .select2-search__field").val("");
        that.$el
          .find("#inb-c-left-bar-flist--begin-location .select2-search__field")
          .val(null)
          .trigger("change");
        $(that).data("state", "unselected");

        that.$el.data("state", "unselected");
        $(this).data("state", "unselected");

        const self = $(this);

        setTimeout(function () {
          self.select2("close");
          // show input field
          that.$el
            .find("#inb-c-left-bar-flist--end-location .select2-search__field")
            .removeClass("hide");
        }, 1);
      });

    // CONTINGENT FILTER
    this.getUI("selectContingent")
      .select2({
        placeholder: this.t("select_${a}", { a: this.t("contingent") }, "capital"),
        maximumSelectionLength: 1,
        allowClear: true,
        matcher: (__, contingent) => {
          const val = that.$el
            .find("#inb-c-left-bar-flist--contingent .select2-search__field")
            .val()
            .toLowerCase();

          if (val == null || val == "") return contingent;

          if (contingent.text.toLowerCase().indexOf(val) > -1) return contingent;

          return null; // no result
        },
      })
      .on("select2:select", function (e) {
        const data = e.params.data,
          filterVal = data.id;

        that.$el.find("#hidden-contingent-filter").trigger("click");
        //that.collection.setFilterAndSort('contingent_id', filterVal, null, null, 'contingent');
        that.collection.addFilter("contingent_id", filterVal, true);

        that._updateFilterSettings({
          filter: "contingent_id",
          type: "contingent",
          value: filterVal,
        });
        // hide input field
        that.$el.find("#inb-c-left-bar-flist--contingent .select2-search__field").addClass("hide");
      })
      .on("select2:unselect", function (e) {
        const data = e.params.data,
          filterVal = data.id;
        //that.$el.find();
        //that.collection.removeFilterFromFilterParams('contingent_id');
        //that._updateFilterSettings({'filter' : 'contingentRemove', 'type' : 'contingent', 'value' : filterVal});
        that.$el.find("#hidden-contingent-filter .unset-filter").trigger("click");
        that.$el.find("#inb-c-left-bar-flist--contingent .select2-search__field").val("");
        //that.$el.find('#inb-c-left-bar-flist--begin-location .select2-search__field').val(null).trigger('change');
        $(that).data("state", "unselected");

        that.$el.data("state", "unselected");
        $(this).data("state", "unselected");

        const self = $(this);

        setTimeout(function () {
          self.select2("close");
          // show input field
          that.$el
            .find("#inb-c-left-bar-flist--contingent .select2-search__field")
            .removeClass("hide");
        }, 1);
      });

    // NETWORK FILTER
    this.getUI("selectNetwork")
      .select2({
        placeholder: this.t("select_${a}", { a: this.t("network") }, "capital"),
        maximumSelectionLength: 1,
        allowClear: true,
        matcher: (__, network) => {
          const val = that.$el
            .find("#inb-c-left-bar-flist--network .select2-search__field")
            .val()
            .toLowerCase();

          if (val == null || val == "") return network;

          if (network.text.toLowerCase().indexOf(val) > -1) return network;

          return null; // no result
        },
      })
      .on("select2:select", function (e) {
        const data = e.params.data,
          filterVal = data.id;

        that.$el.find("#hidden-network-filter").trigger("click");
        //that.collection.setFilterAndSort('contingent_id', filterVal, null, null, 'contingent');
        that.collection.addFilter("network_id", filterVal, true);
        that._updateFilterSettings({
          filter: "network_id",
          type: "network",
          value: filterVal,
        });
        // hide input field
        that.$el.find("#inb-c-left-bar-flist--network .select2-search__field").addClass("hide");
      })
      .on("select2:unselect", function (e) {
        const data = e.params.data,
          filterVal = data.id;
        //that.$el.find();
        //that.collection.removeFilterFromFilterParams('contingent_id');
        //that._updateFilterSettings({'filter' : 'contingentRemove', 'type' : 'contingent', 'value' : filterVal});
        that.$el.find("#hidden-network-filter .unset-filter").trigger("click");
        that.$el.find("#inb-c-left-bar-flist--network .select2-search__field").val("");
        //that.$el.find('#inb-c-left-bar-flist--begin-location .select2-search__field').val(null).trigger('change');
        $(that).data("state", "unselected");

        that.$el.data("state", "unselected");
        $(this).data("state", "unselected");

        const self = $(this);

        setTimeout(function () {
          self.select2("close");
          // show input field
          that.$el
            .find("#inb-c-left-bar-flist--network .select2-search__field")
            .removeClass("hide");
        }, 1);
      });
    let hasFormData = false,
      hasTour = false;
    if (
      typeof this.model.get === "function" &&
      typeof this.model.get("order") !== "undefined" &&
      this.model.get("order") !== null
    ) {
      if (typeof this.model.get("order").tag_list !== "undefined") {
        let tags = this.model.get("order").tag_list.split(",");
        _.each(tags, function (val, k) {
          if (val.trim() === "Anlieferungen") {
            hasFormData = true;
          }
          if (val.trim() === "Tour") {
            hasTour = true;
          }
        });
      }
    }
    this._updateTagList();
  },
});
